import { AlphabetCollectionsDraftApi, useAPIQuery } from "melco-shared-logic";

export const useFontCollectionReferences = (fontCollectionId: string) => {
  return useAPIQuery(
    AlphabetCollectionsDraftApi,
    ["fontCollectionReferences", fontCollectionId],
    async (api) => api.alphabetCollectionsReferences({ id: fontCollectionId })

  );
};
